// tslint:disable:no-any
import { applyMiddleware, compose, createStore, Middleware, Store } from 'redux';
import thunk from 'redux-thunk';

import rootReducer from './reducers';
import { IMakeRequest } from '../helpers/network_helper';

export interface IReduxContext {
  makeRequest: IMakeRequest;
}

const getDevtoolsEnhancer = () => {
  let extension = (f: any) => f;

  if (
    (process.env.NODE_ENV === 'development') &&
    (typeof window === 'object') &&
    (typeof window.devToolsExtension !== 'undefined')
  ) {
    extension = window.devToolsExtension() || extension;
  }

  return extension;
};

export const configureStore = (context: IReduxContext, initialState?: any): Store => {
  const middlewares: Middleware[] = [
    // TODO: update typings
    (thunk as any).withExtraArgument(context),
  ];

  const state = initialState;

  const finalCreateStore = compose(
    applyMiddleware(...middlewares),
    getDevtoolsEnhancer(),
  )(createStore);

  return finalCreateStore(rootReducer, state);
};
